module.exports = __webpack_public_path__ + "fonts/ionicons.2c2ae06.eot";


//////////////////
// WEBPACK FOOTER
// ./~/iview/dist/styles/fonts/ionicons.eot?v=2.0.0
// module id = 453
// module chunks = 14